import { AgGridReact } from "ag-grid-react"; // React Grid Logic

import { useContext, useMemo, useRef } from "react";
import { GlobalContext } from "contexts/GlobalContext";
import "./gridStyles.css";
import { VOL_SURFACE_Month_Estimates_COLS } from "constants/volSurface";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { getRowClass, getRowStyle } from "constants/agGridCommonStyle";
import useUpdateEstimatesTable from "./hooks/useUpdateEstimatesTable";
import { getRowId, isTrader } from "helpers/generalHelper";
import { onGridReady } from "helpers/volSurfaceHelper";

export default function AgGridMonthEstimatesTable() {
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);
  const notTrader = !isTrader();
  const gridRef = useRef();

  const {
    isLoading,
    selectedFilters,
    volCalcTable,
    lockedData,
  } = useVolSurfaceControlTable();
  const columnDefs = useMemo(
    () => VOL_SURFACE_Month_Estimates_COLS(notTrader, lockedData?.is_locked),
    [notTrader, lockedData?.is_locked]
  );

  const { onCellEditingStopped } = useUpdateEstimatesTable({
    gridRef: gridRef,
  });

  const gridOptions = {
    stopEditingWhenGridLosesFocus: false,
  };

  gridOptions.onCellEditingStarted = function (event) {
    var editor = event.api.getCellEditorInstances({
      rowIndex: event.rowIndex,
      column: event.column,
    });
    if (editor && editor.length > 0) {
      editor[0].getGui().style.color = dark_Theme ? "white" : "black";
    }
  };



  if (isLoading || !selectedFilters?.product_id) return null;

  return (
    <div
      className={`${
        dark_Theme || false
          ? "pricer-ag-grid__container_dark"
          : "pricer-ag-grid__container"
      }`}
      style={{
        // height: gridHeight,
        width: "15%",
        padding: "5px 0px 5px 0px",
      }}
    >
      <AgGridReact
        getRowId={getRowId}
        onCellEditingStopped={(event, pricerTablesData) =>
          onCellEditingStopped(event, pricerTablesData)
        }
        headerHeight={30}
        rowHeight={30}
        rowData={volCalcTable}
        getRowStyle={getRowStyle}
        getRowClass={getRowClass}
        ref={gridRef}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        suppressContextMenu
        suppressMovableColumns={true}
        onGridReady={onGridReady}
        className={`ag-theme-alpine pricer-ag-grid__table month-estimates-table ${
          dark_Theme ? " ag-theme-balham-dark" : "ag-theme-balham"
        }`}
      />
    </div>
  );
}
